import React from "react";
import { Skeleton, Spinner } from "@/components/ui";

const ConfigSkeleton: React.FC = () => (
  <div className="flex flex-col gap-3">
    <Skeleton className="w-full h-10 rounded-lg" />
    <Skeleton className="w-full h-24 rounded-lg" />
    <Skeleton className="w-full h-24 rounded-lg" />
  </div>
);

const PreviewLoadingOverlay: React.FC<{ playerName?: string }> = ({ playerName }) => (
  <div className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-2 bg-white">
    <Spinner className="size-6 text-slate-500" />
    <p className="text-sm text-slate-500">Loading {playerName || "player"} preview…</p>
  </div>
);

export { ConfigSkeleton, PreviewLoadingOverlay };
